// extracted by mini-css-extract-plugin
export default {"tournamentsTable":"List_tournamentsTable__+stgU"};